import { createRouter, createWebHistory } from "vue-router";
import axios from 'axios';
import store from '../src/store/index.js';
import { resetAuthenticationForGuest } from '../src/services/guestSession.js';

//import website
import indexPage from "../src/views/index.vue";
import reservationPage from "../src/views/reservation.vue";
import searchPage from "../src/views/search.vue";
import loginPage from "../src/views/login.vue";
import whatsappPage from "../src/views/whatsapp.vue";
import updateDataPage from "../src/views/update_data.vue";
import updatePasswordPage from "../src/views/update_password.vue";
import contentsPage from "../src/views/contents.vue";
import examsPage from "../src/views/exams/index.vue";
import examDetailsPage from "../src/views/exams/show.vue";
import myExamsPage from "../src/views/my_exams/index.vue";
import myExamsDetailPage from "../src/views/my_exams/show.vue";
import privacyPolicyPage from "../src/views/privacy_policy.vue";
import termsOfServicePage from "../src/views/terms_of_service.vue";
import aboutPage from "../src/views/About.vue";
import blogListingPage from "../src/views/blog/BlogListing.vue";
import blogDetailPage from "../src/views/blog/BlogDetail.vue";

// Subscriptions system (student)
import StoreListing from "../src/views/store/Listing.vue";
import ProductDetails from "../src/views/store/ProductDetails.vue";
import SubscribeWizard from "../src/views/subscriptions/Subscribe.vue";
import MySubscriptions from "../src/views/subscriptions/MySubscriptions.vue";
import PaymentHistory from "../src/views/subscriptions/PaymentHistory.vue";
import NotificationsCenter from "../src/views/subscriptions/Notifications.vue";
import SubscriptionRequired from "../src/views/subscriptions/SubscriptionRequired.vue";
// import forgetPage from "../src/views/forget.vue";

// import NotFound from "../src/views/error.vue";


const routes = [
    // Website routes
    { path: "/", component: indexPage, name: "index" },
    { path: "/reservation", component: reservationPage, name: "reservation", meta: { forceGuest: true } },
    { path: "/search", component: searchPage, name: "search" },
    { path: "/whatsapp_link", component: whatsappPage, name: "whatsapp_link", meta: { requiresAuth: true } },
    { path: "/contents", component: contentsPage, name: "contentsPage", meta: { requiresAuth: true } },
    { path: "/update_password", component: updatePasswordPage, name: "update_password", meta: { requiresAuth: true } },
    { path: "/update_data", component: updateDataPage, name: "update_data", meta: { requiresAuth: true } },
    { path: "/exams", component: examsPage, name: "exams", meta: { requiresAuth: true } },
    { path: "/exam/:id", component: examDetailsPage, name: "examDetailsPage", meta: { requiresAuth: true } },
    { path: "/my_exams", component: myExamsPage, name: "myExamsPage", meta: { requiresAuth: true } },
    { path: "/my_exam/:id", component: myExamsDetailPage, name: "myExamsDetailPage", meta: { requiresAuth: true } },
    { path: "/login", component: loginPage, name: "login", meta: { guest: true } },
    { path: "/privacy-policy", component: privacyPolicyPage, name: "privacyPolicy" },
    { path: "/terms-of-service", component: termsOfServicePage, name: "termsOfService" },
    { path: "/about", component: aboutPage, name: "about" },
    { path: "/blogs", component: blogListingPage, name: "blogListing" },
    { path: "/blogs/:slug", component: blogDetailPage, name: "blogDetail" },

    // ── Subscriptions storefront (public) ──
    { path: "/academic-years", component: StoreListing, name: "storeAcademicYears", props: { kind: "academic_year" } },
    { path: "/courses", component: StoreListing, name: "storeCourses", props: { kind: "course" } },
    { path: "/academic-year/:id", component: ProductDetails, name: "academicYearDetails", props: { kind: "academic_year" } },
    { path: "/course/:id", component: ProductDetails, name: "courseDetails", props: { kind: "course" } },
    { path: "/subscription-required", component: SubscriptionRequired, name: "subscriptionRequired" },

    // ── Subscriptions (auth) ──
    { path: "/subscribe", component: SubscribeWizard, name: "subscribe", meta: { requiresAuth: true } },
    { path: "/my-subscriptions", component: MySubscriptions, name: "mySubscriptions", meta: { requiresAuth: true } },
    { path: "/payment-history", component: PaymentHistory, name: "paymentHistory", meta: { requiresAuth: true } },
    { path: "/notifications", component: NotificationsCenter, name: "notifications", meta: { requiresAuth: true } },
    // { path: "/forget", component: forgetPage, name: "forget" },
    // { path: "/404", component: NotFound},
    // { path: "/:catchAll(.*)", redirect: "/404"},
];

const router = createRouter({
    routes,
    history: createWebHistory(),
    hashbang: false,
    mode: 'html5',
    linkActiveClass: "active",
    // linkExactActiveClass: "exact-active",
    scrollBehavior() {
        // Scroll to the top of the page
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
});

// جلب حالة الموقع من localStorage أو من متغير جلوبال
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.forceGuest)) {
        resetAuthenticationForGuest(store, axios);
    }

    const website_status = Number(localStorage.getItem('website_status')) || 0;

    // إذا الصفحة تتطلب تسجيل دخول
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
        } else {
            next('/login');
        }
        return;
    }

    // إذا الصفحة للزوار فقط
    if (to.matched.some(record => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next('/');
        } else {
            next();
        }
        return;
    }

    else if (website_status === 0) {
        const publicPaths = ['/', '/reservation', '/search', '/login', '/whatsapp_link', '/privacy-policy', '/terms-of-service',
            '/academic-years', '/courses', '/subscription-required', '/about', '/blogs'];
        const publicPrefixes = ['/academic-year/', '/course/', '/blogs/'];
        if (publicPaths.includes(to.path) || publicPrefixes.some(p => to.path.startsWith(p))) {
            next();
        } else {
            next('/'); // إعادة توجيه لأي صفحة أخرى
        }
        return;
    }

    // السماح بالانتقال لأي صفحة أخرى
    next();
});

export default router;
